import { ComponentStyleConfig } from '@chakra-ui/theme'

export const Divider: ComponentStyleConfig = {
  baseStyle: {
    opacity: 1,
  },
}
